import React from 'react';
import { FeatureCardContainer } from './style';

const FeatureCard: React.FC = ({ children }) => {
  return <FeatureCardContainer>{children}</FeatureCardContainer>;
};

export default FeatureCard;
